<template>
  <div class="outter">
    <div class="inner">
      <div class="textHeader">
        <p class="modelText">选择添加教材的属性</p>
        <div class="close" @click="close">
          <img src="../../assets/img/close.png" alt="" />
        </div>
      </div>
      <div class="middle">
        <p class="title">选择教材使用届数</p>
        <div>
          <el-select
            class="elSelect"
            v-model="data.period"
            placeholder=" 请选择届数"
          >
            <el-option
              v-for="item in options"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </div>
        <p class="title">选择数量</p>
        <el-input-number
          class="inputNumber"
          size="mini"
          :min="1"
          v-model="data.materialNum"
        ></el-input-number>
        <div class="button" @click="submitAction">确认</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Loading } from 'element-ui'
import { getClassList } from '../../utils/tools'
import { verificationMaterialSheetInfo } from '../../api/wapi'
export default {
  props: ['data'],
  data() {
    return {
      num7: 1,
      options: [],
      value: '',
    }
  },
  computed: {
    ...mapGetters(['resPhone']),
  },
  created() {
    this.options = getClassList()
  },
  methods: {
    checkAdult(item) {
      return item.fid == this.data.fid && item.period == this.data.period
    },
    // 提交
    submitAction() {
      const item = this.data
      let loadingInstance = Loading.service({
        fullscreen: true,
        background: 'rgba(0,0,0,0.5)',
      })
      verificationMaterialSheetInfo(item.fid, this.data.period)
        .then((res) => {
          if (res.data == '2') {
            var list = localStorage.getItem(
              `${this.resPhone}noSubmittedMatList`
            )
            if (list) {
              list = JSON.parse(list)
            } else {
              list = []
            }
            if (list.length > 0) {
              console.log(
                '未提交数据===',
                list.findIndex(this.checkAdult, this)
              )
              if (list.findIndex(this.checkAdult, this) < 0) {
                list.push(item)
                this.$message.success('添加成功')
                this.$emit('close')
              } else {
                this.$message.error('请勿重复添加')
              }
            } else {
              this.$message.success('添加成功，可前往选书库进行提交')
              list.push(item)
              this.$emit('close')
            }
            localStorage.setItem(
              `${this.resPhone}noSubmittedMatList`,
              JSON.stringify(list)
            )
            this.$store.commit('setBookCount', list.length)
            this.$nextTick(() => {
              // 以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close()
            })
          } else {
            this.$nextTick(() => {
              // 以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close()
            })
            this.$confirm(
              `该教材的${this.data.period}届已经添加过了。`,
              '提示',
              {
                showClose: true,
                showCancelButton: false,
                showConfirmButton: false,
              }
            )
          }
        })
        .catch((err) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        })
    },
    // 关闭
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.inputNumber {
  width: 100px !important;
}
/* .elSelect {
  width: 130px;
  height: 30px;
}
.elSelect .el-input__inner {
  height: 30px;
}
.elSelect .el-input__icon {
  line-height: 30px;
} */
</style>
<style lang="scss">
.button {
  width: 60px;
  height: 28px;
  background: #0082F0;
  border-radius: 4px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
  text-align: center;
  margin-top: 44px;
  cursor: pointer;
}
.title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-top: 20px;
  margin-bottom: 10px;
}
.middle {
  padding-left: 22px;
}
.textHeader {
  position: relative;
}
.close {
  position: absolute;
  right: 10px;
  top: 10px;
}
.close img {
  width: 14px;
  height: 14px;
}
.modelText {
  width: 358px;
  height: 30px;
  background: #fff8f7;
  padding-left: 22px;
  line-height: 30px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.outter {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
}
.inner {
  width: 380px;
  height: 280px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  background: #ffffff;
  border: 1px solid #cccccc;
}
</style>